module.exports = __webpack_public_path__ + "img/wind.d5d1f1b9.svg";